import { withNamespaces } from 'react-i18next';
import { RiMagicLine } from 'react-icons/ri';
import {
    Alert,
    Button,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Spinner,
} from 'reactstrap';

import {
    MAILBOX_INTENT_DATA_BREACH_INCIDENT,
    getMailboxAnalysisWarningCopy,
    getMailboxIntentItem,
} from '../../helpers';

const modalIntentLabel = (t, code, item) => (
    code === MAILBOX_INTENT_DATA_BREACH_INCIDENT
        ? t('Data Breach Incident')
        : t(item?.titleKey || 'Case')
);

const MessageIntentAnalysisModal = ({
    t,
    isOpen,
    session,
    analysis,
    isAnalyzing = false,
    analyzingIntent = null,
    analyzingProgress = null,
    isApplying,
    onCancel,
    onConfirm,
}) => {
    const intentItem = getMailboxIntentItem(session?.intent);
    const intentLabel = modalIntentLabel(t, session?.intent, intentItem);
    const analyzingItem = getMailboxIntentItem(analyzingIntent);
    const analyzingLabel = modalIntentLabel(t, analyzingIntent, analyzingItem);
    const warningCopy = getMailboxAnalysisWarningCopy(analysis, t, intentLabel)
        || t(
            'This email does not appear related to {{intent}}. Review the message before creating a case.',
            { intent: intentLabel }
        );

    return (
        <>
        <Modal
            isOpen={isAnalyzing}
            backdrop="static"
            keyboard={false}
            centered
            className="mailbox-analysis-wait"
        >
            <ModalBody className="mailbox-analysis-wait__body">
                <span className="mailbox-analysis-wait__icon" aria-hidden="true">
                    <RiMagicLine />
                </span>
                <Spinner color="primary" className="mb-3" />
                <h5 className="mailbox-analysis-wait__title">
                    {t('Checking this email')}
                </h5>
                <p className="mailbox-analysis-wait__text">
                    {t(
                        'AI is reading this email to see whether it contains the details needed to create a {{intent}}. This can take a little while.',
                        { intent: analyzingLabel }
                    )}
                </p>
                {analyzingProgress?.total > 1 ? (
                    <p className="mailbox-analysis-wait__progress">
                        {t('Email {{current}} of {{total}}', analyzingProgress)}
                    </p>
                ) : null}
            </ModalBody>
        </Modal>
        <Modal
            isOpen={isOpen}
            toggle={isApplying ? undefined : onCancel}
            centered
            unmountOnClose
            className="mailbox-analysis-preview"
        >
            <ModalHeader toggle={isApplying ? undefined : onCancel}>
                {t('Review AI analysis')}
                {intentItem ? ` — ${intentLabel}` : ''}
            </ModalHeader>
            <ModalBody>
                <Alert color="warning" className="mb-0">
                    {warningCopy}
                </Alert>
            </ModalBody>
            <ModalFooter className="mailbox-analysis-preview__footer">
                <Button
                    type="button"
                    color="secondary"
                    onClick={onCancel}
                    disabled={isApplying}
                >
                    {t('Cancel')}
                </Button>
                <Button
                    type="button"
                    color="secondary"
                    outline
                    onClick={onConfirm}
                    disabled={isApplying}
                >
                    {isApplying ? (
                        <Spinner size="sm" className="me-2" />
                    ) : null}
                    {t('Create case anyway')}
                </Button>
            </ModalFooter>
        </Modal>
        </>
    );
};

export default withNamespaces()(MessageIntentAnalysisModal);
